import { render, staticRenderFns } from "./PDPCommentBody.vue?vue&type=template&id=6e06ac59&scoped=true&"
import script from "./PDPCommentBody.vue?vue&type=script&lang=js&"
export * from "./PDPCommentBody.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentBody.vue?vue&type=style&index=0&id=6e06ac59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e06ac59",
  null
  
)

export default component.exports